import { Component, OnInit } from '@angular/core';
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete'
import { MatDialog } from '@angular/material/dialog';
import { ExcelService } from 'src/app/service/excel.service';
import { Constants } from 'src/app/constants';
import { EditInvestigationComponent } from 'src/app/core/dialogs/edit-investigation/edit-investigation.component';
import { InvestigationService } from 'src/app/service/investigation.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EboiStateService } from 'src/app/service/eboi-state.service';
import { Router } from '@angular/router';
import { HomeService } from 'src/app/service/home.service';
import { FgaService } from 'src/app/fga/fga.service';

@Component({
  selector: 'app-investigation',
  templateUrl: './investigation.component.html',
  styleUrls: ['./investigation.component.scss'],
  standalone: false
})
export class InvestigationComponent implements OnInit {
  gridApi: any;
  columnDefs
  successMessage: any;
  errorMessage: string;
  rowData = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  gridOptions
  icons;
  context: any;
  userId: any;
  usersDrpDown: any;
  // rootcauseDropDown: any;
  counterMeasureDropDown: any;
  selected_position_id: number;
  selectedPeriod: any;
  isAccessible: boolean;
  fromPeriodList: any;
  selected_from_period_id: any;
  selected_from_period_value: any;
   totalRecords = 0; 
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
    {value: 20 , selected : false},
		{value: 30 , selected : true},
		{value: 50 , selected : false},
	]
	originalPage: any;
  paginationPageSize: number = 30;
  dynamicHeight: number;

  constructor(public dialog: MatDialog, private readonly constants: Constants,
    private readonly eboiStateService: EboiStateService, private readonly router: Router,
    private readonly investigationService: InvestigationService, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly fga: FgaService
  ) {
    this.context = {
      componentParent: this
    };

    this.gridOptions = {
      suppressCellSelection: true,
      context: this.context,
    }
  }

  ngOnInit(): void {
    //  this.checkRoles();  
    this.dynamicHeight = 0.665 * (window.innerHeight) - 50;
    const tempPeriod = JSON.parse(localStorage.getItem("selected_period"))
    console.info(tempPeriod)
    this.columnDefs = [
      {
        headerName: "Load Number", autoHeight: true, wrapText: true, field: "loadNumber", minWidth: 112, maxWidth: 112,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
      },
      {
        headerName: "Domicile", autoHeight: true, wrapText: true, field: "domicle", unSortIcon: true, sortable: true, minWidth: 112, maxWidth: 112,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
      },
      {
        headerName: "Route", autoHeight: true, wrapText: true, field: "route", unSortIcon: true, sortable: true, minWidth: 112, maxWidth: 112,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
      },
      {
        headerName: "Freq", autoHeight: true, wrapText: true, minWidth: 112, maxWidth: 112, field: "frequency"
      },
      {
        headerName: "$/Freq", autoHeight: true, wrapText: true, minWidth: 112, maxWidth: 112, field: "costPerFrequency"
      },
      {
        headerName: "$/Mile", autoHeight: true, wrapText: true, minWidth: 112, maxWidth: 112, field: "costPerMile"
      },
      {
        headerName: "Trigger", wrapText: true, minWidth: 112, maxWidth: 112, field: "triggerDate", unSortIcon: true, sortable: true, comparator: this.dateComparator
      },
      {
        headerName: "Plan Result", wrapText: true, minWidth: 112, maxWidth: 112, field: "planResultDate"
      },
      {
        headerName: "Actual Result", wrapText: true, minWidth: 112, maxWidth: 112, field: "actualResultDate", cellStyle: this.cellStylingActualResult
      },
      {
        headerName: "Plan Maxload", wrapText: true, minWidth: 112, maxWidth: 112, field: "planMaxLoadDate"
      },
      {
        headerName: "Actual Maxload", wrapText: true, minWidth: 130, maxWidth: 130, field: "actualMaxLoadDate", cellStyle: this.cellStylingActualMaxload
      },
      {
        headerName: "Plan Investigation", wrapText: true, minWidth: 140, maxWidth: 140, field: "planInvestigationDate"
      },
      {
        headerName: "Actual Investigation", wrapText: true, minWidth: 150, maxWidth: 150, field: "actualInvestigationDate", cellStyle: this.cellStylingActualInvestigation
      },
      {
        headerName: "Plan CM", wrapText: true, field: "planCMDate", minWidth: 112, maxWidth: 112,
      },
      {
        headerName: "Actual CM", wrapText: true, field: "actualCMDate", minWidth: 112, maxWidth: 112, cellStyle: this.cellStylingActualCM
      },
      {
        headerName: "Blowout Type", wrapText: true, field: "blowoutType", minWidth: 122, maxWidth: 122,
      },
      {
        headerName: "Edit", wrapText: true, field: "investigation", minWidth: 52, maxWidth: 52, cellRenderer: BtnCellRendererEditDelete
      }
    ]
    // console.info(this.selectedPeriod)
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.componentEventHandler()
    this.investigationDropDowns();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  cellStylingActualResult(params) {
    if (Number(params.data.result_STATUS) == 4) { // NOSONAR
      return { 'background-color': 'red', 'color': 'black' };
    } else if (Number(params.data.result_STATUS) == 3) { // NOSONAR
      return { 'background-color': 'lightgreen', 'color': 'black' };
    }
    return {};
  }

  cellStylingActualMaxload(params) {
    if (Number(params.data.maxload_STATUS) == 4) { // NOSONAR
      return { 'background-color': 'red', 'color': 'black' };
    } else if (Number(params.data.maxload_STATUS) == 3) { // NOSONAR
      return { 'background-color': 'lightgreen', 'color': 'black' };
    }
    return {};
  }

  cellStylingActualInvestigation(params) {
    if (Number(params.data.investigation_STATUS) == 4) {
      return { 'background-color': 'red', 'color': 'black' };
    } else if (Number(params.data.investigation_STATUS) == 3) {
      return { 'background-color': 'lightgreen', 'color': 'black' };
    }
    return {};
  }

  cellStylingActualCM(params) {
    if (Number(params.data.countermeasure_STATUS) == 4) { // NOSONAR
      return { 'background-color': 'red', 'color': 'black' };
    } else if (Number(params.data.countermeasure_STATUS) == 3) { // NOSONAR
      return { 'background-color': 'lightgreen', 'color': 'black' };
    }
    return {};
  }

  async checkRoles() {
    await this.eboiStateService.getRoles();
    const roles = this.eboiStateService.getroleState();
    // const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (!(userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser))) {
    //   this.openRouteLevel('home');
    // }  // Commented for APM integration
  }

  openRouteLevel(route) {
    this.router.navigate([`/${route}`]);
  }

  componentEventHandler() {
    const tempPeriod = JSON.parse(localStorage.getItem("selected_period"))
    if (tempPeriod) {
      this.investigationService.getPeriodsList().subscribe(
        response => {
          if (response.length > 0) {
            this.fromPeriodList = response
            this.selected_from_period_id = tempPeriod
            this.selected_from_period_value = this.fromPeriodList.find(x => x.periodId == this.selected_from_period_id).period // NOSONAR
          }
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.refreshData()
        }, error => {
          console.info(error)
        }
      );

    } else {
      this.investigationService.getPeriodsList().subscribe(
        response => {
          if (response.length > 0) {
            this.fromPeriodList = response
            this.selected_from_period_id = this.fromPeriodList[0].periodId;
            this.selected_from_period_value = this.fromPeriodList.find(x => x.periodId == this.selected_from_period_id).period // NOSONAR
            localStorage.setItem("selected_period", this.selected_from_period_id)
            localStorage.setItem("period_data", JSON.stringify(this.fromPeriodList))
            this.refreshData()
          }
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        }, error => {
          console.info(error)
        }
      );
    }

  }
  periodFunction() {
    this.refreshData()
    localStorage.setItem("selected_period", this.selected_from_period_id)
  }

  async investigationDropDowns() {

    await this.fga.fetchUsersList().then(x => {
      if (x && x.length > 0) {
        this.usersDrpDown = [];
        x.forEach(element => {
          this.usersDrpDown.push({ label: element.firstName + ' ' + element.lastName, value: element.userPrincipalName })
        });
      }
    })

    // await this.investigationService.rootcauseDropDown().then(x => {

    //   if (x && x.length > 0) {
    //     this.rootcauseDropDown = [];
    //     x.forEach(element => {
    //       this.rootcauseDropDown.push({ label: element.description, value: element.rootCauseId })
    //     });
    //   }
    // })

    await this.investigationService.counterMeasureDropDown().then(x => {

      if (x && x.length > 0) {
        this.counterMeasureDropDown = [];
        x.forEach(element => {
          this.counterMeasureDropDown.push({ label: element.description, value: element.counterMeasureId })
        });
      }
    })
  }

  editTemplateRow(data) {
    const dialogRef = this.dialog.open(
      EditInvestigationComponent, {
      disableClose: true,
      width: '920px',
      data: {
        header: 'Edit Expedite Investigation',
        eventType: 'EDIT',
        usersDrpDown: this.usersDrpDown,
        // rootcauseDropDown: this.rootcauseDropDown,
        counterMeasureDropDown: this.counterMeasureDropDown,
        investigationId: data.investigationId,
        dateOfTrigger: data.triggerDate,
        domicile: data.domicle,
        resUser: data.responsibleUserId,
        plannedBlowout: data.plannedBlowout,
        owkBlowouts: data.owkBlowout,
        loadNumber: data.loadNumber,
        route: data.route,
        blowouts: data.frequency,
        rootCauseId: data.rootCauseId,
        countermeasure: data.counterMeasureId,
        planMaxloadTargetDate: data.planMaxLoadDate,
        oWKMaxloadTargetDate: data.planResultDate,
        actualInvestigationComplete: data.actualInvestigationDate,
        planMaxloadActualDate: data.actualResultDate,
        oWKMaxloadActualDate: data.actualMaxLoadDate,
        actualCountermeasureComplete: data.actualCMDate
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR

        this.successMessage = this.constants.APIDataUpdated;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();

      }
    });
  }

  refreshData() {
    this.displayRowData = []
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.investigationService.loadInvestigation(this.selected_from_period_id).subscribe(//this.selectedPeriod
      response => {

        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        this.totalRecords = this.displayRowData.length;
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          setTimeout(() => {
          this.updatePaginationDetails();
        });
     
      },
      error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }

 goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

	onPageSizeChanged(event: any) { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails(); }

	getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}
  

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }




}


function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 10) { // NOSONAR
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
